export default "__VITE_ASSET__CCwqLaJd__"